import axios from 'axios';
import { Index } from 'flexsearch';
import { STORES, getItem, putItem } from '../utilities/indexedDB';

const icons = {
  plus: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6V18M6 12H18" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  minus: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 12H18" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg>'
};

window.addEventListener('load', async function() {
    const FAQ_CACHE_KEY = 'faq_blogs';
    const FAQ_TTL_MS = 3 * 3600 * 1000;
    const FAQ_STORE = STORES.PRODUCTS_NOLAYOUT;

    const getBlogsAndStore = async () => {
        try {
            const cached = await getItem(FAQ_STORE, FAQ_CACHE_KEY);
            if (cached && Array.isArray(cached.blogs) && cached.expiresAt > Date.now()) {
                return cached.blogs;
            }

            const response = await axios.get('/blogs/faq?view=nolayout.faq');
            const blogsData = response.data;

            try {
                await putItem(FAQ_STORE, {
                    sectionKey: FAQ_CACHE_KEY,
                    blogs: blogsData,
                    expiresAt: Date.now() + FAQ_TTL_MS,
                });
            } catch (err) {
                console.warn('Search failed to write IDB cache', err);
            }

            return blogsData;
        } catch (error) {
            console.error('Error fetching blogs:', error);
            return [];
        }
    };

    const allBlogs = await getBlogsAndStore();

    function togglefaq(element, articleHandle, isInitialLoad = false) {
        const content = document.getElementById(`content-${articleHandle}`);
        const toggleButton = element.querySelector(".faq_article_toggle");
        const iconContainer = toggleButton.querySelector(".faq_toggle_icon");
        const isCurrentlyOpen = toggleButton.getAttribute("aria-expanded") === "true";

        const currentlyOpenButton = document.querySelector('.faq_article_toggle[aria-expanded="true"]');
        if (currentlyOpenButton && currentlyOpenButton !== toggleButton) {
            const currentlyOpenContent = document.getElementById(
                currentlyOpenButton.getAttribute("aria-controls")
            );
            currentlyOpenContent.style.display = "none";
            currentlyOpenContent.setAttribute("aria-hidden", "true");
            currentlyOpenButton.setAttribute("aria-expanded", "false");
            currentlyOpenButton.classList.remove("active");
            currentlyOpenButton.querySelector(".faq_toggle_icon").innerHTML = icons.plus;
        }

        if (!isCurrentlyOpen) {
            content.style.display = "block";
            content.setAttribute("aria-hidden", "false");
            toggleButton.setAttribute("aria-expanded", "true");
            toggleButton.classList.add("active");
            iconContainer.innerHTML = icons.minus;

            if (!isInitialLoad) {
                content.focus();
                if (window.location.pathname.includes('/blogs/')) {
                  const afterBlogs = window.location.pathname.split('/blogs/')[1] || '';
                  const blogSlug = afterBlogs.split('/')[0] || '';
                  const articlePath = String(articleHandle).replace(new RegExp(`^${blogSlug}/`), '');
                  const newUrl = `${window.location.origin}/blogs/${blogSlug}/${articlePath}`;
                  window.history.replaceState({}, '', newUrl);
                }
            }
        } else {
            content.style.display = "none";
            content.setAttribute("aria-hidden", "true");
            toggleButton.setAttribute("aria-expanded", "false");
            toggleButton.classList.remove("active");
            iconContainer.innerHTML = icons.plus;

            if (!isInitialLoad && window.location.pathname.includes('/blogs/')) {
                const currentPath = window.location.pathname.split('/blogs/')[1];
                const blogCategory = currentPath ? currentPath.split('/')[0] : '';
                if (blogCategory) {
                  const newUrl = `${window.location.origin}/blogs/${blogCategory}`;
                  window.history.replaceState({}, '', newUrl);
                }
            }
        }
    }

    window.togglefaq = togglefaq;

    const afterBlogs = window.location.pathname.split('/blogs/')[1];
    if (afterBlogs) {
        const parts = afterBlogs.split('/').filter(Boolean);
        const articleHandle = parts.length >= 2 ? `${parts[0]}/${parts.slice(1).join('/')}` : null;
        const articleElement = document.querySelector(`[id="content-${articleHandle}"]`);
        const toggleButton = document.querySelector(`[aria-controls="content-${articleHandle}"]`);

        if (articleElement && toggleButton) {
            togglefaq(toggleButton.parentElement, articleHandle, true);
        } else {
            console.error("No match:", articleHandle);
        }
    }

    async function setupSearch() {
        const searchInput = document.querySelector('.faq_search_input');
        const searchResultsContainer = document.querySelector('.faq_search_results_container');

        let blogs = await getBlogsAndStore();

        const synonymMap = {
            "shipping": ["delivery", "postage", "freight"],
            "refund": ["return", "credit"],
            "order": ["purchase", "buy", "transaction"],
        };

        const index = new Index({
            tokenize: "full",
            threshold: 1,
            encoder:"icase",
            depth: 10,
            doc: {
                id: "id",
                field: ["title", "content", "tags"],
            },
        });

        if (blogs && blogs.length > 0) {
            blogs.forEach((blog, idx) => {
                index.add(idx, `${blog.title} ${blog.content} ${blog.tags.join(" ")}`);
            });
        } else {
            console.error("No blogs found in local storage or from server.");
        }

        function expandQueryWithSynonyms(query) {
            return query.split(" ").flatMap(word => {
                const synonyms = synonymMap[word.toLowerCase()];
                if (synonyms) {
                    return [word, ...synonyms];
                }
                return [word];
            }).join(" ");
        }

        function highlightQueryFuzzy(text, query) {
            if (!text) return '';
            const regex = new RegExp(`(${query.split('').join('|')})`, 'gi');
            return text.replace(regex, '<strong>$1</strong>');
        }

        searchInput.addEventListener('input', async function () {
            const query = searchInput.value.trim();
            if (!query) {
                searchResultsContainer.style.display = 'none';
                searchInput.setAttribute('aria-expanded', 'false');
                return;
            }
            let currentBlogs = blogs;
            if (!currentBlogs || currentBlogs.length === 0) {
                currentBlogs = await getBlogsAndStore();
                blogs = currentBlogs;
                index.reset();
                currentBlogs.forEach((blog, idx) => {
                    index.add(idx, `${blog.title} ${blog.content} ${blog.tags.join(" ")}`);
                });
            }

            const expandedQuery = expandQueryWithSynonyms(query);
            let resultIds = index.search(query, { threshold: 1 });
            const expandedResultIds = index.search(expandedQuery, { threshold: 1 });
            const allResultIds = [...new Set([...resultIds, ...expandedResultIds])];
            const results = allResultIds.map(id => blogs[id]).filter(Boolean);

            if (results.length > 0) {
                searchResultsContainer.style.display = 'block';
                searchInput.setAttribute('aria-expanded', 'true');
                searchResultsContainer.innerHTML = results
                    .map((blog, idx) => {
                        const plainTitle = blog?.title ? blog.title : 'Untitled';
                        const title = highlightQueryFuzzy(plainTitle, query);
                        let handle = blog?.handle ? blog.handle : '#';
                        if (handle && handle !== '#') {
                            handle = handle.replace(/^\/blogs\//, '').replace(/^\/+/, '');
                            handle = `/blogs/${handle}`;
                        }
                        const aria = `Link to ${plainTitle}`.replace(/"/g, '&quot;');
                        const optionLabel = plainTitle.replace(/"/g, '&quot;');
                        const id = `faq_option_${idx}`;
                        return `<li id="${id}" role="option" aria-selected="false" aria-label="${optionLabel}" data-href="${handle}" tabindex="-1">
                                    <span aria-hidden="true">${title}</span>
                                </li>`;
                    })
                    .join('');
            } else {
                searchResultsContainer.style.display = 'none';
                searchInput.setAttribute('aria-expanded', 'false');
            }
        });

        document.addEventListener('click', function (event) {
            if (!event.target.closest('.faq_search_input_container')) {
                searchResultsContainer.style.display = 'none';
                searchInput.setAttribute('aria-expanded', 'false');
            }
        });

        searchResultsContainer.addEventListener('click', function (e) {
            const option = e.target.closest('[role="option"][data-href]');
            if (option) {
                const href = option.getAttribute('data-href');
                if (href) window.location.href = href;
            }
        });

    }

    await setupSearch();
});